// import { getFaqBySlug } from "@/handlers/faq";
import { MasterConfigContext } from "@/context/MasterConfigContext";
import useIsMobile from "@/hooks/useIsMobile";
import dynamic from "next/dynamic";
import { useContext } from "react";
const ElectionPage = dynamic(() => import("@/screens/StateElection"));
const PageLayout = dynamic(() => import("@/screens/Layout/PageLayout"));

export default function ElectionTab({
  latestStoryData = null,
  latestVideoData = null,
  categoryNewsListData = null,
  constituencyListData = null,
  candidateData = null,
  constHindiName = null,
  constituencyDetailData = null,
  electionCategory = null,
  ConstituencyliveBlogData = null,
}) {
  const isMobileDevice = useIsMobile();

  const masterConfig = useContext(MasterConfigContext);
  const biharElectionKey = masterConfig["bihar_election"];
  const const_year = biharElectionKey?.constDetailYear
  // console.log("candidateData", constituencyDetailData);
  // let metaData = {
  //   title: `${candidateData?.[0]?.ac_name} Election Result ${const_year} Winner: ${constHindiName} विधानसभा चुनाव परिणाम, Runner-Up, Vote Share & Updates - Newstak`,
  //   description:
  //     candidateData?.[0]?.win_loss == "WON"
  //       ? `${candidateData?.[0]?.ac_name} Vidhan Sabha Chunav Result ${
  //           const_year
  //         }: ${constHindiName} विधानसभा चुनाव ${const_year} में ${
  //           candidateData?.[0]?.party_h
  //         } के ${candidateData?.[0]?.candidate_h} ने ${
  //           candidateData?.[1]?.party_h
  //         } के ${candidateData?.[1]?.candidate_h} को ${
  //           candidateData?.[0]?.votes - candidateData?.[1]?.votes
  //         } वोटों से हराया। जानिए किस उम्मीदवार को कितने वोट मिले, वोट शेयर, जीत का मार्जिन और सभी जरूरी अपडेट सिर्फ Newstak.in पर।`
  //       : `${candidateData?.[0]?.ac_name} Vidhan Sabha Chunav Result ${const_year}: ${constHindiName} विधानसभा चुनाव ${const_year} के नतीजे LIVE - जानिए कौन उम्मीदवार कितने वोटों से आगे चल रहा है, किसे कितने वोट मिले और जीत-हार का पूरा अपडेट सिर्फ Newstak.in पर।`,
  //   keywords: `${candidateData?.[0]?.ac_name} election news, ${candidateData?.[0]?.ac_name} election result ${const_year}, ${candidateData?.[0]?.ac_name} assembly election winner, ${candidateData?.[0]?.ac_name} vote share, Bihar election ${const_year} result, ${candidateData?.[0]?.ac_name} vidhan sabha seat result, ${candidateData?.[0]?.ac_name} MLA result, ${candidateData?.[0]?.ac_name} live vote count, ${constHindiName} विधानसभा नतीजे, ${constHindiName} विधानसभा चुनाव, ${constHindiName} विधानसभा चुनाव परिणाम, ${constHindiName} विधानसभा चुनाव परिणाम ${const_year}`,
  // };
  let metaData

  return (
    <section>
      <PageLayout
        latestStoryData={latestStoryData}
        latestVideoData={latestVideoData}
        isMobileDevice={isMobileDevice}
      >
        <ElectionPage
          // electionPath="delhi-assembly/constituency-list"
          electionPath={`${electionCategory}/constituency-list`}
          categoryNewsListData={categoryNewsListData}
          isMobileDevice={isMobileDevice}
          constituencyListData={constituencyListData}
          candidateData={candidateData}
          constHindiName={constHindiName}
          electionPassedCategory={electionCategory} //'delhi-assembly'
          stateName="Bihar"
          stateHindi="बिहार"
          metaData={metaData}
          constituencyDetailData={constituencyDetailData}
          masterKey={"bihar_election"}
          ConstituencyliveBlogData={ConstituencyliveBlogData}
        />
      </PageLayout>
    </section>
  );
}
//staticpages?url=sample-faqs
export const getServerSideProps = async (ctx) => {
  const { logger } = await import("@/utils/logging/log-util");
  try {
    let url = ctx?.resolvedUrl;

    let pathParts = url.replace("/elections/", "").split("/");

    let electionCategory = `${pathParts[0]}/${pathParts[1]}`;
    const getUrl = `/elections/${electionCategory}`;
    // console.log("getUrl--", url?.split("-result-")[1]);
    const { getLatestStoryVideoFeed, splitLatestStoryVideoFeed } = await import("@/handlers/content");
    const { MasterConfigContext } = await import(
      "@/context/MasterConfigContext"
    );
    const { getRedisApiKey, fetchRedisWrapper } = await import(
      "@/handlers/redisKey"
    );
    const { getDataByUrl } = await import("@/handlers/commonApi");
    const { setPageTTL } = await import("@/utils/setPageTTL");
    const { getUnixTimeDaysAgo } = await import("@/utils/dateTimeFormat");

    const unixtime = getUnixTimeDaysAgo(15);

    const masterConfig = await fetch(
      `${process.env.BASE_PATH + process.env.API_PREFIX
      }/masterconfig`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
      }
    ).then(async (res) => {
      return await res.json();
    });
    let electionConfig = masterConfig?.data;

    // const electionConfig = useContext(MasterConfigContext);

    // console.log("the elction config is" , electionConfig)

    //* get page from query param and subtract 1 from it , also error handle if not a number
    let page = ctx?.query?.page;
    if (isNaN(page)) {
      page = 0;
    }
    page = page ? parseInt(page) - 1 : 0;

    //* get redis api key for each api
    let categoryListRedisKey = getRedisApiKey({
      redisPrefix: "PREFIX_REDIS_ROS",
      params: {
        api: "getdatabyurl",
        url: getUrl, // url,
        page: page,
        display: 12,
        type: "all",
      },
    });

    // faq key
    // let faqRedisKey = getRedisApiKey({
    //   masterConfigData: masterConfigData,
    //   redisPrefix: "PREFIX_REDIS_ROS",
    //   params: { api: "staticpages", url: "sample-faqs" },
    // });

    //* get redis api key for each api
    const latestStoryVideoRedisKey = getRedisApiKey({
      redisPrefix: "PREFIX_REDIS_ROS",
      params: {
        api: "latestcontentfeed",
        page: 0,
        display: 5,
        type: "story,video",
        unixtime,
      },
    });

    let constituencyListData = null;

    let constituencyUrl = `https://akm-img-a-in.tosshub.com/sites/elections/2025/assembly/json/state-master/bihar-state-master.json`;
    await fetch(constituencyUrl, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    }).then(async (data) => {
      const data1 = await data.json();
      // console.log("constituencyListData", data1?.data);
      constituencyListData = data1?.data;
    });

    let constId = ctx?.resolvedUrl?.split("?")[0].split("-").pop();
    const selfUrl = constituencyListData?.find((item) => parseInt(item?.cons_id) === parseInt(constId))?.sef_url?.replace(/–/g, "-")

    // redirect to correct url
    const parts = ctx.resolvedUrl?.split("/") || [];

    if (parts.length < 5) {
      return { notFound: true };
    }

    const state = parts[3];
    const constituency = parts[4]
      ?.replace(/-assembly-constituency-result-\d+$/, "")
      ?.replace(/–/g, "-");

    const pageUrl = `${state}/${constituency}`;

    if (
      selfUrl &&
      constId &&
      pageUrl !== selfUrl
    ) {
      const destination = `${process.env.NEXT_PUBLIC_WEBSITE_URL}/elections/assembly-chunav/${encodeURI(
        selfUrl
      )}-assembly-constituency-result-${constId}`;

      return {
        redirect: {
          destination,
          statusCode: 301,
        },
      };
    }
    let constHindiName =
      constituencyListData &&
      constituencyListData?.filter(
        (item) => parseInt(item?.cons_id) === parseInt(constId)
      )[0]?.cons_name_hi;

    let candidateData = null;
    let constituencyDetailData = null;

    let candidateUrl = `https://akm-img-a-in.tosshub.com/sites/elections/2025/assembly/json/constituency/bihar/${constId}.json`;
    await fetch(candidateUrl, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    }).then(async (data) => {
      const tempCand = await data.json();

      candidateData = tempCand?.data?.candidate;
      constituencyDetailData = tempCand?.data;
    });

    // constituency live blog api-----------------------------------------------
    let ConstituencyliveBlogData = null;
    let ConstituencyliveBlogUrl = `${process.env.BASE_PATH}/nwtak/api/get-election-constituency-data?id=${constId}`;

    try {
      const response = await fetch(ConstituencyliveBlogUrl, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
      });

      const tempCand = await response.json();

      if (tempCand?.status_code === 0 || !tempCand?.data) {
        ConstituencyliveBlogData = null;
      } else {
        ConstituencyliveBlogData = tempCand.data;
      }
    } catch (err) {
      console.error(err);
      ConstituencyliveBlogData = null;
    }

    let [
      categoryNewsListData,
      { latestStoryData, latestVideoData },
      //  faqData
    ] = await Promise.all([
      fetchRedisWrapper(categoryListRedisKey, () =>
        getDataByUrl({
          url: getUrl, // url,
          page: page,
          display: 12,
          type: "all",
        })
      ),
      fetchRedisWrapper(latestStoryVideoRedisKey, () =>
        getLatestStoryVideoFeed({
          page: 0,
          display: 5,
          unixtime,
        })
      ).then(splitLatestStoryVideoFeed),
      // fetchRedisWrapper(faqRedisKey, () =>
      //   getFaqBySlug({
      //     url: "sample-faqs",
      //   })
      // ),
    ]);

    // let headerCache = categoryNewsListData?.cache;
    setPageTTL(ctx, 60);
    // console.log("categoryNewsListData", categoryNewsListData);
    return {
      props: {
        categoryNewsListData,
        latestStoryData,
        latestVideoData,
        constituencyListData,
        candidateData,
        constHindiName,
        constituencyDetailData,
        electionCategory,
        // faqData,
        ConstituencyliveBlogData,
      },
    };
  } catch (error) {
    logger.error(error);
    return {
      notFound: true,
    };
  }
};
